import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import {Accordion, AccordionSummary, Button, ButtonGroup, Icon, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";
import {Brand} from "../../../models/Brand";
import React from "react";
import {IconType} from "react-icons";

interface ButtonFilterProps {
    title: string,
    filteredValue: Brand | undefined | boolean,
    setFilteredValue: (x: any) => void,
    buttonObjects: ButtonObject[],
    attributeName: string,
}

interface ButtonObject {
    img?: string,
    Icon?: IconType,
    value: Brand | boolean,
    imgAlt: string,
    imgBorderRadius: string
}

export default observer(function ButtonFilter({title, filteredValue, setFilteredValue, buttonObjects, attributeName}: ButtonFilterProps){
    const { AccordionStore } = useStore();
    const {filteredAccordions} = AccordionStore;

    const filteredResultsAvailable = (buttonObject: ButtonObject): boolean => {
        if(filteredValue !== undefined) return true;
        // @ts-ignore
        return filteredAccordions.filter(a => a[attributeName] === buttonObject.value).length > 0
    }

    return (
        <Accordion variant={'outlined'} defaultExpanded={true}>
            <AccordionSummary
                expandIcon={<ExpandMore />}
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <ButtonGroup
                variant={'text'}
                color={'secondary'}
                sx={{width:'80%', pb: 2}}
            >
                {
                    buttonObjects.map(o =>
                        <Button
                            disabled={!filteredResultsAvailable(o)}
                            key={o.value+o.imgAlt}
                            variant={(filteredValue === o.value ? 'contained' : 'text')}
                            sx={{width: '50%'}}
                            onClick={() => setFilteredValue(o.value)}
                        >
                            {
                                o.img ?
                                    <img src={o.img} alt={o.imgAlt} style={{height: '30px', width: '30px', borderRadius: o.imgBorderRadius}} /> :
                                    o.Icon ? <o.Icon style={{fontSize: '30px'}} /> :
                                    o.imgAlt
                            }
                        </Button>
                    )
                }
            </ButtonGroup>
        </Accordion>
    )
})